import { FileCheck2, Handshake, PenLine, ShieldCheck, Target, TrendingUp } from "lucide-react";
import { marketEntry } from "@/content/site";
import { Reveal } from "@/components/motion/Reveal";
import { SectionHeader } from "@/components/common/SectionHeader";
import { ButtonLink } from "@/components/common/ButtonLink";
import { IconCard, StepStrip } from "./IconCards";

const ICONS = { selection: Target, filings: FileCheck2, matching: Handshake, structuring: PenLine, channel: ShieldCheck, launch: TrendingUp };

// Home section for manufacturers and suppliers (anchor: #market-entry).
export const MarketEntry = ({ index }) => (
  <section id="market-entry" className="section-y scroll-mt-24 border-t border-line" data-testid="market-entry-section">
    <div className="container-x">
      <SectionHeader eyebrow={marketEntry.eyebrow} index={index} title={marketEntry.title} body={marketEntry.intro} className="mb-14" />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {marketEntry.items.map((item, i) => (
          <IconCard key={item.id} icon={ICONS[item.id]} title={item.title} body={item.body} i={i} testId={`market-entry-item-${item.id}`} />
        ))}
      </div>
      <Reveal className="mt-12">
        <StepStrip steps={marketEntry.steps} testId="market-entry-steps" />
      </Reveal>
      <Reveal className="mt-10">
        <ButtonLink to={marketEntry.cta.to} variant="accent" testId="market-entry-cta">
          {marketEntry.cta.label}
        </ButtonLink>
      </Reveal>
    </div>
  </section>
);
